export { default } from './es/icons/DocumentFilled';